import { ENVIRONMENTS } from "constants";

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  // All parts of this config field are optional.
  // if none of the inputs are set, it's an empty string which means the API is hosted at same domain
  // (i.e in hosted emulator, PR preview, or live)
  baseApiHostPath: `${import.meta.env.VITE_BASE_API_PROTOCOL?.concat("://") ?? ""}${import.meta.env.VITE_BASE_API_HOST ?? ""}${
    import.meta.env.VITE_BASE_API_PATH ?? ""
  }`,
  appCheckRecaptchaSiteKey: import.meta.env
    .VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY,
};

export const SENTRY = {
  dsn: 'https://3401e24ec6ef179ef3ae0c0a09fdb57f@o1163346.ingest.us.sentry.io/4508961390329856',
  sampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: "",
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
};

export const MIXPANEL = {
    projectToken: '37ac65b8f317cd6bccd7236be34cb2ad'
}

// Basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = "";
export const { IMAGE_PATH } = window.config;

const config = {
  fontFamily: `'Inter','Roboto', sans-serif`,
  borderRadius: 8,
  outlinedFilled: true,
  navType: "light", // Light, dark
  presetColor: "theme1", // Default, theme1, theme2, theme3, theme4, theme5, theme6
  locale: "en", // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
  rtlLayout: false,
  container: false,
  env: import.meta.env.VITE_ENVIRONMENT || ENVIRONMENTS.LOCAL,
  showErrors: import.meta.env.VITE_SHOW_ERRORS === "true",
  version: import.meta.env.VITE_VERSION,
};

export default config;
